import { Component, Inject, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface button {
    text: string;
    class: string;
}

@Component({
    selector: 'confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent {
    public buttonClick = false;

    public loading = false;

    @Input() type: 'default' | 'delete' = 'default';

    @Output() onSubmit: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            title?: string;
            body?: string;
            confirmLabel: string;
            cancelLabel: string;
            confirmType?: 'default' | 'delete';
        },
    ) {}

    onNoClick(): void {
        this.cancel();
    }

    confirm(): void {
        this.onSubmit.emit(true);
    }

    cancel(): void {
        this.onSubmit.emit(false);
    }

    get typeClass() {
        return this.data.confirmType == 'default' ? 'bciti-button no-transition bciti-button--blue' : 'bciti-button no-transition bciti-button--red';
    }
}
